import React from 'react';

export interface IconCocktailProps {
  className?: string;
  size?: number | string;
  color?: string;
  fill?: string;
  stroke?: string;
}

const IconCocktail: React.FC<IconCocktailProps> = ({ 
  className = '', 
  size = 24, 
  color = 'currentColor', 
  fill, 
  stroke 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      color={color}
      fill={fill || 'none'}
    >
       <g clipPath="url(#clip0_29_1607)"> <path d="M6.32959 6.42859L12.1381 13.2857L17.9466 6.42859H6.32959Z" fill={fill || "#020617"}  stroke={stroke || "#020617"}  strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="square" /> <path d="M12.1384 13.2858V21.0001" stroke={stroke || "#020617"}  strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="square" /> <path d="M8.73395 21H15.5425" stroke={stroke || "#020617"}  strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="square" /> <path d="M9 6L5.90426 3H2.5" stroke={stroke || "#020617"}  strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="square" /> <path d="M16.3936 5.57143C16.3936 4.15029 17.5366 3 18.9468 3C20.3553 3 21.5 4.15029 21.5 5.57143C21.5 6.99257 20.3553 8.14286 18.9468 8.14286C18.4583 8.14286 18.003 8.00571 17.6157 7.76743" stroke={stroke || "#020617"}  strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="square" /> </g> <defs> <clipPath id="clip0_29_1607"> <rect width="24" height="24" fill={fill || "white"} /> </clipPath> </defs>  
    </svg>
  );
};

export default IconCocktail;
